<template>
  <v-list id="mobile-drawer-menu" v-if="menu == 'default'" :style="{ color: props.style.color }">
    <v-list-item
      v-for="item in menuItems"
      v-show="item.menu_item"
      :key="item.id"
      :to="item.home ? '/' : '/' + item.slug"
    >
      <v-list-item-content :style="props.style">
        <v-list-item-title>{{ item.name }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
  <v-list id="mobile-drawer-menu" v-else :style="{ color: props.style.color }">
    <component
      v-for="item in menuItems"
      :key="item.id"
      :is="
        item.children.length
          ? 'parent-mobile-menu-button'
          : `${item.type}-mobile-menu-button`
      "
      :props="props"
      :item="item"
      class="menu-item"
    ></component>
  </v-list>
</template>

<script>
import { activeTemplate } from '@/graphql/template.gql'
import PageMobileMenuButton from './PageMobileMenuButton'
import SectionMobileMenuButton from './SectionMobileMenuButton'
import UrlMobileMenuButton from './UrlMobileMenuButton'
import ParentMobileMenuButton from './ParentMobileMenuButton'
import FileMobileMenuButton from './FileMobileMenuButton'

export default {
  name: 'BaseMobileMenu',
  props: {
    menu: {
      type: String
    },
    props: {
      type: Object,
      required: true
    }
  },
  components: {
    PageMobileMenuButton,
    SectionMobileMenuButton,
    UrlMobileMenuButton,
    ParentMobileMenuButton,
    FileMobileMenuButton
  },
  computed: {
    menuItems() {
      return this.menu == 'default'
        ? this.activeTemplate.pages
        : this.activeTemplate.menus
            .filter(menu => menu.id == this.menu)
            .map(menu => menu.parent_items)[0]
    }
  },
  apollo: {
    activeTemplate: {
      query: activeTemplate
    }
  }
}
</script>

<style>
.v-navigation-drawer__content > #mobile-drawer-menu.v-list * {
  color: inherit !important;
}
</style>
